import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Common/withRouter";
import { createSelector } from "reselect";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";

import { useSelector } from "react-redux";
import { logOutUser } from "../../../helpers/dataBackend";

const ProfileMenu = (props: any) => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();

  const selectProfileProperties = createSelector(
    (state: any) => state.Login,
    (login) => ({
      user: login.user,
    })
  );

  const { user } = useSelector(selectProfileProperties);
  useEffect(() => {}, [user]);

  const handleLogOut = async () => {
    const tokenParam = (await localStorage.getItem("authUser")) || "";
    // console.log("Token Param", tokenParam);
    const token = JSON.parse(atob(tokenParam.split(".")[1]));
    try {
      if (token.exp * 1000 < Date.now()) {
        console.log("Entra en IF");
        // alert("Token expired");
        localStorage.removeItem("authUser");
        localStorage.removeItem("userInfo");
        sessionStorage.removeItem("persist:root");
        localStorage.removeItem("refreshToken");
        navigate("/login");
      } else {
        console.log("Entra en ELSE");
        navigate("/login");
        await logOutUser();
        localStorage.removeItem("authUser");
        localStorage.removeItem("userInfo");
        sessionStorage.removeItem("persist:root");
        localStorage.removeItem("refreshToken");
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{user}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem>
            <Link to={"/profile"}>
              <i className="bx bx-user font-size-16 align-middle me-1" />
              {props.t("Profile")}{" "}
            </Link>{" "}
          </DropdownItem>

          <DropdownItem tag="a" href="#">
            {/* <span className="badge bg-success float-end">11</span> */}
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Button className="dropdown-item" onClick={() => handleLogOut()}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Button>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(ProfileMenu));
